import { Vue } from 'vue-class-component';
import { CustomizeDealContainer } from '@/components/views/customize-deal/components/customize-deal-container';

export class CustomizeDealView extends Vue {
	render() {
		return (
			<CustomizeDealContainer />
		);
	}
}
